import { fetchQuery, graphql } from "relay-runtime"
import {
  GetAvailableDatesCapacityInput,
  useAvailableDatesCapacityQuery,
} from "@/modules/patients/services/__generated__/useAvailableDatesCapacityQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const availableDatesCapacity = graphql`
  query useAvailableDatesCapacityQuery($input: GetAvailableDatesCapacityInput!) {
    availableDatesCapacity(filter: $input) {
      availableDates
      isIrrelevant
    }
  }
`

export type AvailableDates = useAvailableDatesCapacityQuery["response"]["availableDatesCapacity"]

export const fetchAvailableDatesCapacity = (input: GetAvailableDatesCapacityInput, signal: AbortSignal) => {
  return fetchQuery<useAvailableDatesCapacityQuery>(
    RelayEnvironment,
    availableDatesCapacity,
    { input },
    {
      fetchPolicy: "store-or-network", // Use this option to prevent unnecessary call requests when the user switches back to previous filters.
      networkCacheConfig: { metadata: { signal } },
    },
  ).toPromise()
}
